// @flow
import * as React from 'react';
import {Handle, Position} from 'react-flow-renderer';

const SIZE = 16;
const OFFSET = SIZE / 2;
const dimensions = {
  width: `${SIZE}px`,
  height: `${SIZE}px`,
};
type GeneratorHandleProps = {|
  top?: string,
  translateX?: number,
|};

type HandleProps = {|
  type: 'source' | 'target',
|};

// A special handle that we use for building sequence diagrams in the
// Diagram generator. Sits at the top of the vertical bar.
export const SequenceDiagramGeneratorHandle = ({
  top,
  translateX,
}: GeneratorHandleProps) => (
  <Handle
    type="source"
    position={Position.Right}
    className="diagram-generator"
    id="auto"
    style={{
      top: top || 'calc(50% - 8px)',
      width: '16px',
      height: '16px',
      background: 'white',
      border: '1px solid black',
      textAlign: 'center',
      transform: `translateX(${translateX || 0}px)`,
    }}
  />
);

const TopLeftHandle = ({type}: HandleProps) => (
  <Handle
    type={type}
    position={Position.Top}
    id="top left"
    style={{...dimensions, left: '25%', top: `-${OFFSET}px`}}
  />
);

const TopHandle = ({type}: HandleProps) => (
  <Handle
    type={type}
    position={Position.Top}
    id="top"
    style={{...dimensions, left: '50%', top: `-${OFFSET}px`}}
  />
);

const TopRightHandle = ({type}: HandleProps) => (
  <Handle
    type={type}
    position={Position.Top}
    id="top right"
    style={{...dimensions, left: '75%', top: `-${OFFSET}px`}}
  />
);

export const TopHandles = () => (
  <>
    <TopLeftHandle type="target" />
    <TopLeftHandle type="source" />
    <TopHandle type="target" />
    <TopHandle type="source" />
    <TopRightHandle type="target" />
    <TopRightHandle type="source" />
  </>
);

const BottomLeftHandle = ({type}: HandleProps) => (
  <Handle
    type={type}
    position={Position.Bottom}
    id="bottom left"
    style={{...dimensions, left: '25%', bottom: `-${OFFSET}px`}}
  />
);

const BottomHandle = ({type}: HandleProps) => (
  <Handle
    type={type}
    position={Position.Bottom}
    id="bottom"
    style={{...dimensions, left: '50%', bottom: `-${OFFSET}px`}}
  />
);

const BottomRightHandle = ({type}: HandleProps) => (
  <Handle
    type={type}
    position={Position.Bottom}
    id="bottom right"
    style={{...dimensions, left: '75%', bottom: `-${OFFSET}px`}}
  />
);

export const BottomHandles = () => (
  <>
    <BottomLeftHandle type="target" />
    <BottomLeftHandle type="source" />
    <BottomHandle type="target" />
    <BottomHandle type="source" />
    <BottomRightHandle type="target" />
    <BottomRightHandle type="source" />
  </>
);

const LeftTopHandle = ({type}: HandleProps) => (
  <Handle
    type={type}
    id="left top"
    position={Position.Left}
    style={{...dimensions, top: '25%', left: `-${OFFSET}px`}}
  />
);

const LeftHandle = ({type}: HandleProps) => (
  <Handle
    type={type}
    id="left"
    position={Position.Left}
    style={{...dimensions, top: '50%', left: `-${OFFSET}px`}}
  />
);

const LeftBottomHandle = ({type}: HandleProps) => (
  <Handle
    type={type}
    id="left bottom"
    position={Position.Left}
    style={{...dimensions, top: '75%', left: `-${OFFSET}px`}}
  />
);

export const LeftHandles = () => (
  <>
    <LeftTopHandle type="target" />
    <LeftTopHandle type="source" />
    <LeftHandle type="target" />
    <LeftHandle type="source" />
    <LeftBottomHandle type="target" />
    <LeftBottomHandle type="source" />
  </>
);

const RightTopHandle = ({type}: HandleProps) => (
  <Handle
    type={type}
    id="right top"
    position={Position.Right}
    style={{...dimensions, top: '25%', right: `-${OFFSET}px`}}
  />
);

const RightHandle = ({type}: HandleProps) => (
  <Handle
    type={type}
    id="right"
    position={Position.Right}
    style={{...dimensions, top: '50%', right: `-${OFFSET}px`}}
  />
);

const RightBottomHandle = ({type}: HandleProps) => (
  <Handle
    type={type}
    id="right bottom"
    position={Position.Right}
    style={{...dimensions, top: '75%', right: `-${OFFSET}px`}}
  />
);

export const RightHandles = () => (
  <>
    <RightTopHandle type="target" />
    <RightTopHandle type="source" />
    <RightHandle type="target" />
    <RightHandle type="source" />
    <RightBottomHandle type="target" />
    <RightBottomHandle type="source" />
  </>
);
